import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Icon, Header, Container} from 'semantic-ui-react';
import {isNil} from 'ramda';
import styled from 'styled-components';
import {retrieveTeam, signupCommunityUser} from '../../api';
import UserProfileForm from './UserProfileForm';

const Message = styled.div`
  display: flex;
  flex-direction: ${props => props.column ? 'column' : 'row'};
  justify-content: center;
  align-items: center;
  & > h3, & > p, & > i {
    color: #ffffff;
  }
`;

class SignupTeamForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      team: null
    };
  }
  
  componentDidMount() {
    const {router: {params: {teamId}}} = this.props;
    return retrieveTeam(teamId)
      .then(response => this.setState({team: response.data}));
  }
  
  render() {
    const {team} = this.state;
    const school = !isNil(team) ? team.school : null;
    const teamName = !isNil(team) ? team.name : null;

    const onCreate = requestBody => signupCommunityUser(team.id, requestBody);

    return (
      <div>
        {!isNil(team) ?
          (
            <div>
              <Header as="h3" icon textAlign="center" style={{color: '#ffffff'}}>
                <Header.Content>{`Welcome to team "${teamName}"!`}</Header.Content>
              </Header>
              <Container textAlign="center" style={{color: '#ffffff'}}>
                <p>Fill out the form below to sign up for a new BodyBank account, and join the team.</p>
              </Container>
            </div>
          )
          : (
            <Message>
              <Icon name="circle notched" loading={isNil(team)}/>
              <p>Loading team...</p>
            </Message>
          )}
        <UserProfileForm schoolId={school ? school.id : null} onCreate={onCreate}/>
      </div>
    );
  }
}

SignupTeamForm.propTypes = {
  router: PropTypes.object.isRequired
};

export default SignupTeamForm;



// WEBPACK FOOTER //
// ./src/components/Form/SignupTeamForm.js